var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0713 13.234C8.31731 20.334 6.34264 24.18 6.14731 24.772C6.03269 25.0153 5.98358 25.2844 6.00483 25.5525C6.02608 25.8206 6.11696 26.0785 6.26848 26.3008C6.42 26.523 6.6269 26.7018 6.86873 26.8195C7.11056 26.9373 7.37893 26.9898 7.64731 26.972C8.66464 26.972 12.6743 25.172 19.6763 21.572",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7573 21.1635C21.7338 20.187 20.6258 17.4964 18.2824 15.1531C15.9391 12.8097 13.2486 11.7017 12.272 12.6782C11.2955 13.6547 12.4036 16.3453 14.7469 18.6886C17.0903 21.032 19.7808 22.14 20.7573 21.1635Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 16.0332C9.84916 16.8111 10.7165 18.9512 12.571 20.8057C14.4255 22.6602 16.5657 23.5276 17.3435 22.7498",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7573 15.634C16.7384 15.4476 16.7658 15.2594 16.8371 15.0862C16.9085 14.9129 17.0216 14.76 17.1663 14.641C17.6183 14.251 19.0983 13.9 19.0983 13.022C19.0983 12.144 17.3683 11.751 17.6493 10.513C17.7806 10.0683 18.0302 9.66748 18.3712 9.35332C18.7123 9.03917 19.1323 8.8234 19.5863 8.72899C20.1896 8.31966 20.3406 7.86799 20.0393 7.37399",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0923 17.5C20.5976 16.4347 22.4283 16.2864 23.5843 17.055",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5563 13.5C22.7552 13.5 22.946 13.421 23.0866 13.2803C23.2273 13.1397 23.3063 12.9489 23.3063 12.75C23.3063 12.5511 23.2273 12.3603 23.0866 12.2197C22.946 12.079 22.7552 12 22.5563 12C22.3574 12 22.1666 12.079 22.0259 12.2197C21.8853 12.3603 21.8063 12.5511 21.8063 12.75C21.8063 12.9489 21.8853 13.1397 22.0259 13.2803C22.1666 13.421 22.3574 13.5 22.5563 13.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5563 16.5C25.7552 16.5 25.946 16.421 26.0866 16.2803C26.2273 16.1397 26.3063 15.9489 26.3063 15.75C26.3063 15.5511 26.2273 15.3603 26.0866 15.2197C25.946 15.079 25.7552 15 25.5563 15C25.3574 15 25.1666 15.079 25.0259 15.2197C24.8853 15.3603 24.8063 15.5511 24.8063 15.75C24.8063 15.9489 24.8853 16.1397 25.0259 16.2803C25.1666 16.421 25.3574 16.5 25.5563 16.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5563 6.5C17.7552 6.5 17.946 6.42098 18.0866 6.28033C18.2273 6.13968 18.3063 5.94891 18.3063 5.75C18.3063 5.55109 18.2273 5.36032 18.0866 5.21967C17.946 5.07902 17.7552 5 17.5563 5C17.3574 5 17.1666 5.07902 17.0259 5.21967C16.8853 5.36032 16.8063 5.55109 16.8063 5.75C16.8063 5.94891 16.8853 6.13968 17.0259 6.28033C17.1666 6.42098 17.3574 6.5 17.5563 6.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5563 5.5C22.7552 5.5 22.946 5.42098 23.0866 5.28033C23.2273 5.13968 23.3063 4.94891 23.3063 4.75C23.3063 4.55109 23.2273 4.36032 23.0866 4.21967C22.946 4.07902 22.7552 4 22.5563 4C22.3574 4 22.1666 4.07902 22.0259 4.21967C21.8853 4.36032 21.8063 4.55109 21.8063 4.75C21.8063 4.94891 21.8853 5.13968 22.0259 5.28033C22.1666 5.42098 22.3574 5.5 22.5563 5.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5563 9.5C23.7552 9.5 23.946 9.42098 24.0866 9.28033C24.2273 9.13968 24.3063 8.94891 24.3063 8.75C24.3063 8.55109 24.2273 8.36032 24.0866 8.21967C23.946 8.07902 23.7552 8 23.5563 8C23.3574 8 23.1666 8.07902 23.0259 8.21967C22.8853 8.36032 22.8063 8.55109 22.8063 8.75C22.8063 8.94891 22.8853 9.13968 23.0259 9.28033C23.1666 9.42098 23.3574 9.5 23.5563 9.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5563 8.5C15.7552 8.5 15.946 8.42098 16.0866 8.28033C16.2273 8.13968 16.3063 7.94891 16.3063 7.75C16.3063 7.55109 16.2273 7.36032 16.0866 7.21967C15.946 7.07902 15.7552 7 15.5563 7C15.3574 7 15.1666 7.07902 15.0259 7.21967C14.8853 7.36032 14.8063 7.55109 14.8063 7.75C14.8063 7.94891 14.8853 8.13968 15.0259 8.28033C15.1666 8.42098 15.3574 8.5 15.5563 8.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55627 13.5C9.75519 13.5 9.94595 13.421 10.0866 13.2803C10.2273 13.1397 10.3063 12.9489 10.3063 12.75C10.3063 12.5511 10.2273 12.3603 10.0866 12.2197C9.94595 12.079 9.75519 12 9.55627 12C9.35736 12 9.1666 12.079 9.02594 12.2197C8.88529 12.3603 8.80627 12.5511 8.80627 12.75C8.80627 12.9489 8.88529 13.1397 9.02594 13.2803C9.1666 13.421 9.35736 13.5 9.55627 13.5Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9713 9.665C13.8076 8.90805 13.5351 8.17881 13.1623 7.5C12.8003 6.984 12.6213 6.75 11.9273 6.75C11.6432 6.72589 11.3582 6.78372 11.106 6.91665C10.8538 7.04958 10.645 7.25203 10.5043 7.5C10.3903 7.71232 10.3307 7.94954 10.3307 8.1905C10.3307 8.43147 10.3903 8.66869 10.5043 8.881C10.5606 9.0039 10.645 9.11179 10.7509 9.19589C10.8567 9.27999 10.9809 9.33793 11.1133 9.365",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.2f6c4b6512da989236359c8363f0c607.svg";
export { ForwardRef as ReactComponent };